import { render, staticRenderFns } from "./vchart.vue?vue&type=template&id=60f188a4&scoped=true&"
import script from "./vchart.vue?vue&type=script&lang=js&"
export * from "./vchart.vue?vue&type=script&lang=js&"
import style0 from "./vchart.vue?vue&type=style&index=0&id=60f188a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f188a4",
  null
  
)

export default component.exports